import { Component, HostBinding, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-content-section',
	template: '<ng-content></ng-content>',
	styleUrls: ['./content-section.component.scss'],
})
export class ContentSectionComponent {
	@Input() public readonly bordered: boolean = true;
	@Input() public readonly outlined: boolean = false;
	@Input() public readonly rounded: boolean = false;
	@Input() public readonly borderColor: string = `primary`;
	@Input() public readonly backgroundColor: string = `transparent`;
	@Input() public readonly marginHorizontal: boolean = true;
	@Input() public readonly marginBottom: boolean = true;
	@Input() public readonly padding: boolean = true;
	@Input() public readonly columns: boolean = false;
	@HostBinding('class.m--bordered') public get isBordered(): boolean {
		return this.bordered;
	}
	@HostBinding('class.m--outlined') public get isOutlined(): boolean {
		return this.outlined;
	}
	@HostBinding('class.m--rounded') public get isRounded(): boolean {
		return this.rounded;
	}
	@HostBinding('class.m--primary') public get isPrimary(): boolean {
		return this.borderColor === `primary`;
	}
	@HostBinding('class.m--accent') public get isAccent(): boolean {
		return this.borderColor === `accent`;
	}
	@HostBinding('class.m--warn') public get isWarn(): boolean {
		return this.borderColor === `warn`;
	}
	@HostBinding('class.m--secondary') public get isSecondary(): boolean {
		return this.borderColor === `secondary`;
	}
	@HostBinding('class.m--bg-primary') public get isBgPrimary(): boolean {
		return this.backgroundColor === `primary`;
	}
	@HostBinding('class.m--bg-accent') public get isBgAccent(): boolean {
		return this.backgroundColor === `accent`;
	}
	@HostBinding('class.m--bg-warn') public get isBgWarn(): boolean {
		return this.backgroundColor === `warn`;
	}
	@HostBinding('class.m--margin-horizontal') public get isMarginHorizontal(): boolean {
		return this.marginHorizontal;
	}
	@HostBinding('class.m--margin-bottom') public get isMarginBottom(): boolean {
		return this.marginBottom;
	}
	@HostBinding('class.m--padding') public get isPadding(): boolean {
		return this.padding;
	}
	@HostBinding('class.m--columns') public get isColumnCount(): boolean {
		return this.columns;
	}

	constructor() { }
}
